import { render, staticRenderFns } from "./phoneIndex.vue?vue&type=template&id=79a02a9d&scoped=true"
import script from "./phoneIndex.vue?vue&type=script&lang=js"
export * from "./phoneIndex.vue?vue&type=script&lang=js"
import style0 from "./phoneIndex.vue?vue&type=style&index=0&id=79a02a9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a02a9d",
  null
  
)

export default component.exports